module.exports = __webpack_public_path__ + "img/feature_buy_th.b6950e80.png";